export const initialSelectedClient = {
    id: "",
    status: "",
    creator: "",
    buyerIdAdquirente: "",
    buyerCardIdAdiquirente: null,
    buyerbranch: {
        businessName: "",
    },
    firstName: "",
    lastName: "",
    email: "",
    phoneNumber: "",
    taxpayerId: "",
    addressPostalCode: "",
    addressCity: "",
    addressState: "",
    addressLine1: "",
    addressneighborhood: "",
    addressLine2: "",
    addressLine3: ""
}